/* global SideDrawer */

if (!customElements.get('localization-drawer')) {
  class LocalizationDrawer extends SideDrawer {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.flagsLoaded = false;

      // adjacent toggles
      const drawerId = this.dataset.triggeredBy;
      this.localizationToggles = document.querySelectorAll(`[data-localization-trigger="${drawerId}"]`);

      // overlay
      this.overlay = document.querySelector('.js-localization-overlay');

      // Form & input fields
      this.countryCode = this.querySelector('[name="country_code"]');
      this.languageCode = this.querySelector('[name="locale_code"]');

      // Country + language pair buttons - one button sets both fields at once,
      // rather than the country and language being two separate steps.
      this.localizationPairs = this.querySelectorAll('.js-localization-pair');

      // Flag elements to lazy load
      this.localizationFlags = this.querySelectorAll('.localization-country__flag');

      // Event listeners
      this.localizationToggles.forEach((el) => {
        el.addEventListener('click', (evt) => this.toggleLocalization(evt.currentTarget));
      });

      this.localizationPairs.forEach((pair) => {
        pair.addEventListener('click', this.selectPair.bind(this));
      });
    }

    selectPair({ currentTarget }) {
      // The button itself is a real submit button now, so the native click
      // submits the form on its own right after this runs - no need to also
      // call form.submit() here, which depended on the form lookup in init()
      // resolving correctly to work at all.
      if (this.countryCode) this.countryCode.value = currentTarget.dataset.country;
      if (this.languageCode) this.languageCode.value = currentTarget.dataset.locale;
    }

    /**
     * Opens the drawer.
     * @param {Element} [opener] - Element that triggered opening of the drawer.
     */
    toggleLocalization(opener) {
      if (this.localizationToggles.length === 0) return;

      const isActive = !this.localizationToggles[0].classList.contains('is-active');

      this.localizationToggles.forEach((el) => {
        el.classList.toggle('is-active', isActive);
        el.setAttribute('aria-expanded', isActive);
      });

      this.filtersOpen = isActive;
      this.open(opener);
      this.loadFlagImages();
    }

    loadFlagImages() {
      if (this.flagsLoaded) return;

      this.localizationFlags.forEach((flag) => {
        const flagUrl = flag.getAttribute('data-flag-url');
        if (flagUrl) {
          flag.style.setProperty('--flag-image', `url(${flagUrl})`);
        }
      });

      this.flagsLoaded = true;
    }
  }

  customElements.define('localization-drawer', LocalizationDrawer);
}
